\rentware-item-price
    display: inline
